import { bankServices } from "../../config/axios";
import {
    BLOCK_USERDETAILS_SUCCESS,
    BLOCK_USERDETAILS_FAILED,
    RESET_BLOCK_USERDETAILS,
    LOADING_BLOCK_USERDETAILS,
    BLOCK_USERDETAILS_NETWORKERROR,
} from '../types/index';

const resetblockUserManagement = () => {
    return { type: RESET_BLOCK_USERDETAILS };
};

const blockUserManagement = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BLOCK_USERDETAILS });
    await bankServices
        .post("getBlockUser", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BLOCK_USERDETAILS_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BLOCK_USERDETAILS_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BLOCK_USERDETAILS_FAILED,
        payload: data
    };
}

export { resetblockUserManagement, blockUserManagement }